import React, { useEffect, useRef } from 'react';
import HeroImage from '@app/assets/images/anonymize-pro/document.png';
import HeroRedactedImage from '@app/assets/images/anonymize-pro/document_redacted.png';
import Image from 'next/image';
import ImageRenderer from '@app/components/media-renderer/image-renderer';

function HeroImageEffect() {
    const redactedImageRef = useRef(null);

    const handleIntersection = (entries: [any]) => {
        const [entry] = entries;
        if (entry.isIntersecting) {
            // @ts-ignore
            redactedImageRef.current.classList.add('slide-in');
            // @ts-ignore
            redactedImageRef.current.classList.add('opacity-100');
        }
    };

    // Animate only when the image container is seen on the viewport
    useEffect(() => {
        if (redactedImageRef?.current !== null) {
            // @ts-ignore
            const observer = new IntersectionObserver(handleIntersection, { threshold: 1 });
            observer.observe(redactedImageRef.current as Element);
            return () => observer.disconnect();
        }
    }, [redactedImageRef]);

    return (
        <div className="group relative aspect-hero-image w-full lg:w-[764px]">
            <ImageRenderer media={HeroImage} isGrayScale={false} className="absolute" />

            <div ref={redactedImageRef} className={'absolute overflow-hidden opacity-0'}>
                <div className={'w-full lg:w-[764px]'}>
                    <ImageRenderer isGrayScale={false} media={HeroRedactedImage} />
                </div>
            </div>
        </div>
    );
}

export default HeroImageEffect;
